import React from 'react';
import PropTypes from 'prop-types';
import { HStack, Button } from '@chakra-ui/react';

import Link from '@repo/ui-components/tailwind/Link';
import { useUiComponentsInternationalContext } from '@repo/static-translations';

import menuCollectionSorter from '../../../layout/Header/menuCollectionSorter';

function LinkButton({ title, pathname, active, ...props }) {
  return (
    <Button
      as={Link}
      className={`rounded-[6.2rem] font-bold text-nowrap ${
        active ? 'text-muted-foreground border-cta' : ''
      }`}
      isActive={active}
      link={`/${pathname}`}
      textStyle="caption"
      variant="tertiary"
      {...props}
    >
      {title}
    </Button>
  );
}

LinkButton.defaultProps = { active: false };

LinkButton.propTypes = {
  title: PropTypes.string.isRequired,
  pathname: PropTypes.string.isRequired,
  active: PropTypes.bool,
};

export default function CurrentGroupMobile({ currentGroup }) {
  const { tt } = useUiComponentsInternationalContext();

  return (
    <HStack w="full" pos="relative" overflowX="auto" wrap="nowrap" py="2">
      <LinkButton
        title={currentGroup.parentCollection.title}
        pathname={currentGroup.parentCollection.pathname}
        active={currentGroup.parentCollection.active}
        aria-label={tt(s => s.blocksDeptComponents.viewAllProductsLabel, {
          title: currentGroup.parentCollection.title,
        })}
      />
      {menuCollectionSorter(
        currentGroup.parentCollection?.store?.title,
        currentGroup
      ).childCollections?.map(c => (
        <LinkButton
          key={c._id}
          title={c.title}
          active={c.active}
          pathname={c.pathname}
          aria-label={tt(s => s.blocksDeptComponents.viewAllProductsLabel, {
            title: c.title,
          })}
        />
      ))}
    </HStack>
  );
}

CurrentGroupMobile.propTypes = {
  currentGroup: PropTypes.shape({
    parentCollection: PropTypes.shape({
      title: PropTypes.string.isRequired,
      pathname: PropTypes.string.isRequired,
      active: PropTypes.bool,
      store: PropTypes.shape({
        title: PropTypes.string.isRequired,
      }),
    }).isRequired,
    childCollections: PropTypes.arrayOf(
      PropTypes.shape({
        _id: PropTypes.string.isRequired,
        active: PropTypes.bool,
        pathname: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
};
